import { router } from 'expo-router';
import { observer } from 'mobx-react-lite';
import { StyleSheet } from 'react-native';

import { BackChevron } from '@/components/BackChevron';
import { ErrorState } from '@/components/ErrorState';
import { Screen } from '@/components/Screen';
import { Text } from '@/components/Text';
import { spacing } from '@/constants/theme';
import { GIFTING_ROUTES } from '@/lib/giftingRoute';
import { giftingStore } from '@/stores/gifting.store';

/**
 * What product detail and confirm render when the product isn't in the
 * catalog: load error → retry, definitively absent → back to the grid,
 * otherwise still loading. One component because the two screens had the
 * exact same three-way block copy-pasted.
 */
// Its own observer, not a plain child (adversarial review, same class as
// the shipping-form finding): the parent screens only track products in
// their render scope, so a loadError flip would never re-render a plain
// child — the retry ErrorState below would be unreachable and "Loading…"
// would stick forever on a failed fetch.
export const GiftFallbackScreen = observer(function GiftFallbackScreen() {
  const { loaded, loading, loadError } = giftingStore;

  return (
    <Screen>
      <BackChevron onPress={() => router.replace(GIFTING_ROUTES.choose)} />
      {loadError ? (
        <ErrorState
          title="Couldn't load this gift"
          body="Check your connection and try again."
          onRetry={() => void giftingStore.load()}
        />
      ) : loaded && !loading ? (
        <ErrorState
          title="Gift not found"
          body="That gift isn't part of the current campaign."
          retryLabel="Back to gifts"
          onRetry={() => router.replace(GIFTING_ROUTES.choose)}
        />
      ) : (
        <Text color="textMuted" align="center" style={styles.loadingText}>
          Loading…
        </Text>
      )}
    </Screen>
  );
});

const styles = StyleSheet.create({
  loadingText: {
    paddingVertical: spacing.xl,
  },
});
